import { useScript } from "@uidotdev/usehooks";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import HelperPlatform from 'utils/helper-platform'
import Ajax from 'utils/request/ajax'
import { configClient } from 'components/provider/ConfigProvider'
import { validateCaptcha } from 'utils/validate-captcha'

const Captcha = forwardRef( ( {}, ref ) => {
	
	const [ key ] = useState( '6LffSlUqAAAAAM8aLqxx7yLufmS3navAIhJuRJ3M' ); // v3
	const [ greCaptchaLoadStatus, setGreCaptchaLoadStatus ] = useState( null );
	const cancelValidation = useRef( null );

	useEffect( () => {
		return () => {
			cancelValidation.current?.();
		};
	}, [] );
	
	useImperativeHandle( ref, () => {
		return (
			{
				validate( callback ) {
					cancelValidation.current?.();
					// When not web it is always valid!
					if( !HelperPlatform.isWeb() ) {
						callback({ isValid: true });
						return
					}

					// In web we need to validate the captcha
					if( greCaptchaLoadStatus === 'ready' && typeof grecaptcha !== 'undefined' ) {
						cancelValidation.current = validateCaptcha({
							execute: () => {
								return grecaptcha.execute( key, { action: 'submit' });
							},
							verify: ( token, finish ) => {
								Ajax.request( configClient.url() + '/connection/rest/captcha/verify', {
									variables: {
										value: token,
									},
									onSuccess: ( result ) => {
										finish( result?.status === 'success' );
									},
									onError: () => {
										finish( false );
									},
								});
							},
							callback,
						});
					} else {
						callback({ isValid: false });
					}
				},
			}
		);
	});
	
	if( !HelperPlatform.isWeb() ) {
		return null;
	}
	
	// Load the script!
	const status = useScript(
		`https://www.google.com/recaptcha/api.js?render=${key}`,
		{
			removeOnUnmount: true,
		}
	);
	
	useEffect( () => {
		setGreCaptchaLoadStatus( status );
	}, [ status ] );
	
	return null;
})

export default Captcha
